import React from 'react';

interface FlightRangeFooterActionsProps {
  onCancel: () => void;
  onSaveDraft: () => void;
  onModify: () => void;
}

const FlightRangeFooterActions: React.FC<FlightRangeFooterActionsProps> = ({
  onCancel,
  onSaveDraft,
  onModify
}) => {
  return (
    <div className="flight-range-modify__footer">
      <div className="flight-range-modify__footer-container">
        <div className="flight-range-modify__footer-left">
          <auro-button
            className="flight-range-modify__go-back-button"
            onClick={onCancel}
            aria-label="Go back to flight ranges admin page"
            variant='secondary'
            size='md'
            data-testid="cancel-button"
          >
            Go back
          </auro-button>
          <auro-button
            className="flight-range-modify__save-draft-button"
            onClick={onSaveDraft}
            aria-label="Save changes as draft"
            variant='tertiary'
            size='md'
            data-testid="save-draft-button"
          >
            Save as draft
          </auro-button>
        </div>
        <div className="flight-range-modify__footer-right">
          <auro-button
            className="flight-range-modify__modify-button"
            onClick={onModify}
            aria-label="Apply modifications to flight ranges"
            variant="primary"
            size="lg"
            responsive
            fluid
            data-testid="modify-button"
            style={
                {
                '--ds-auro-button-container-image': 'var(--color-primary, #0074ca)',
                padding: 'var(--padding-size-150, 12px) var(--padding-size-300, 24px)',
                minWidth: '212px',
                height: '50px'
                } as React.CSSProperties
            }
          >
            Modify flight ranges
          </auro-button>
        </div>
      </div>
    </div>
  );
};

export default FlightRangeFooterActions;
